<template>
  <button
    :class="classes"
    :type="form ? 'submit' : false"
    :disabled="isDisabled"
  >
    <component
      v-if="displayedIconLeft"
      :is="displayedIconLeft"
      :extra-classes="extraIconClasses"
    />
    {{ text }}
    <component
      v-if="displayedIconRight"
      :is="displayedIconRight"
      :extra-classes="extraIconClasses"
    />
  </button>
</template>

<script>
  import Arrow from '@/components/icons/Arrow'
  import Bolt from '@/components/icons/Bolt'
  import Check from '@/components/icons/Check'
  import Heart from '@/components/icons/Heart'
  import Spinner from '@/components/icons/Spinner'
  import SignOut from '@/components/icons/SignOut'
  import Rotate from '@/components/icons/Rotate'

  export default {
    name: 'link-button',
    props: {
      type: {
        type: String,
        default: 'primary',
      },
      submit: {
        type: Boolean,
      },
      text: {
        type: String,
        required: true,
      },
      iconRight: {
        type: String,
      },
      iconLeft: {
        type: String,
      },
      iconClasses: {
        type: Array,
        default: () => [],
      },
      form: {
        type: String,
      },
      extraClasses: {
        type: Array,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      disableOnSubmit: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Arrow,
      Bolt,
      Check,
      Heart,
      Rotate,
      Spinner,
      SignOut,
    },
    computed: {
      classes() {
        let classes = ['button', `button--${this.type}`]

        if (this.extraClasses) {
          classes = classes.concat(this.extraClasses)
        }

        const isSubmittingForm =
          this.form && this.$store.getters.isFormSubmitting(this.form)
        if (this.disabled) {
          classes.push('button--disabled')
        }
        if (isSubmittingForm) {
          classes.push('button--submitting')
        }
        return classes.join(' ')
      },
      displayedIconLeft() {
        if (!this.iconLeft) {
          return false
        }

        if (this.form && this.$store.getters.isFormSubmitting(this.form)) {
          return 'Spinner'
        } else {
          return this.iconLeft
        }
      },
      displayedIconRight() {
        if (!this.iconRight) {
          return false
        }
        if (this.form && this.$store.getters.isFormSubmitting(this.form)) {
          return 'Spinner'
        } else {
          return this.iconRight
        }
      },
      extraIconClasses() {
        let classes = [`button__icon-${this.iconRight ? 'right' : 'left'}`]
        return classes.concat(this.iconClasses)
      },
      isDisabled() {
        if (this.disabled) {
          return true
        }
        if (!this.disableOnSubmit) {
          return false
        }
        return this.form && this.$store.getters.isFormSubmitting(this.form)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .button {
    .icon {
      width: 1em;
      vertical-align: middle;
      line-height: 1em;

      &--bolt {
        width: 0.7em;
      }
    }

    &--small {
      .icon {
        width: 0.8em;
        vertical-align: middle;
        line-height: 1em;
      }
    }
  }
</style>
